module.exports = "data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw=="


/*****************
 ** WEBPACK FOOTER
 ** C:/Users/Maciek/Desktop/Praca/offon.pl/~/fancybox/dist/img/blank.gif
 ** module id = 19
 ** module chunks = 0
 **/